import { MainCard } from '@armhr/ui';
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { paths } from '../../utils/paths';

const W2ReminderCard: React.FC = () => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(true);

  const isDecember = new Date().getMonth() === 11;

  if (!isDecember || !isVisible) {
    return null;
  }

  return (
    <MainCard
      border={false}
      sx={{
        transition: 'all 0.3s ease-in-out',
        background: alpha(theme.palette.primary.light, 0.1),
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <IconButton
        size="small"
        onClick={() => setIsVisible(false)}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          borderRadius: 4,
          color: 'text.secondary',
          zIndex: 1,
          '&:hover': {
            bgcolor: 'white',
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          {/* Hero Icon - Compact Version */}
          <Box
            sx={{
              position: 'relative',
              display: 'inline-flex',
              flexShrink: 0,
              mt: 0.5,
            }}
          >
            <DescriptionIcon
              sx={{
                fontSize: 48,
                color: alpha(theme.palette.primary.main, 0.2),
              }}
            />
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                top: '45%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontWeight: 900,
                fontSize: '0.75rem',
                color: 'primary.main',
              }}
            >
              W-2
            </Typography>
          </Box>

          <Box sx={{ pr: 3 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              W-2 season is coming!
            </Typography>
            <Typography variant="body1">
              Be sure to review your personal information such as home address
              and name by <strong>December 31</strong> to ensure accuracy of
              your W-2.
            </Typography>
          </Box>
        </Stack>

        <Box
          sx={{
            bgcolor: 'white',
            borderRadius: 2,
            p: 1.5,
            border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', lineHeight: 1.5 }}
          >
            Click{' '}
            <Link
              component={RouterLink}
              to={paths.w2}
              sx={{ fontWeight: 'bold' }}
            >
              this link
            </Link>{' '}
            to make an election for electronic W-2s. If selected, you won't
            receive a paper copy. Without election, a paper copy will be mailed
            to your home address.
          </Typography>
        </Box>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Button
            size="small"
            variant="outlined"
            component={RouterLink}
            to={paths.profile}
          >
            Update personal info
          </Button>
          <Button
            size="small"
            variant="contained"
            component={RouterLink}
            to={paths.w2}
          >
            Go to W-2 Page
          </Button>
        </Stack>
      </Stack>
    </MainCard>
  );
};

export default W2ReminderCard;
